import React from 'react';
import {render} from 'react-dom';
import createHashHistory from 'history/createHashHistory';
import {routerMiddleware} from 'react-router-redux';
import configureStore from './store/configureStore';
import Root from './containers/Root'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css'
import 'react-select/dist/react-select.css';
import 'pikaday/css/pikaday.css'
import './resources/css/style.css';
import "moment/locale/cs";


const hashHistory = createHashHistory();
const router = routerMiddleware(hashHistory);

const store = configureStore(router);

render(
	<Root store={store} history={hashHistory}/>,
	document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js